import { EventEmitter, Input, Output } from '@angular/core';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

export abstract class FormComponentControl extends FormControlBase<any> {
  @Input() id: string;
  @Input() label: string;
  @Input() placeholder = '';
  @Output() blur: EventEmitter<any> = new EventEmitter();
  _isFocus = false;
  _isBlur = true;
  @Input() browserIE = false;

  get isInvalid() {
    if (!this.browserIE && this.control) {
      return this._isBlur && (this.submitted || this.control.touched) && this.control.invalid;
    }
    return false;
  }

  get isValid() {
    return false;
  }

  get isSubmit(): boolean {
    return this.submitted;
  }

  @Input()
  set isSubmit(value: boolean) {
    this.submitted = value;
  }

  onFocus() {
    this._isFocus = true;
    this._isBlur = false;
  }

  onBlur() {
    this._isFocus = false;
    this._isBlur = true;
    this.blur.emit(this.value);
  }
}
